module.exports = __webpack_public_path__ + "static/media/ArrowUpsideEnd.1d113206.svg";